export default __webpack_public_path__ + "static/card-8-423fb9fabbdd29f59438e3d34d0e0543.png";